var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60757 10.0791C3.86071 10.0791 4.0699 9.891 4.10301 9.64695L4.10757 9.5791V0.500583C4.10757 0.224441 3.88372 0.000582695 3.60757 0.000582695C3.35444 0.000582695 3.14525 0.188685 3.11214 0.432735L3.10757 0.500583V9.5791C3.10757 9.85524 3.33143 10.0791 3.60757 10.0791Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97164 3.58394C6.16646 3.77965 6.48304 3.78038 6.67875 3.58557C6.85667 3.40847 6.87345 3.13073 6.72867 2.93466L6.68038 2.87847L3.96187 0.147354C3.78419 -0.0311484 3.50535 -0.0473757 3.30928 0.0986719L3.25313 0.147354L0.534608 2.87847C0.339797 3.07418 0.340529 3.39076 0.536242 3.58557C0.714162 3.76267 0.991975 3.77817 1.18738 3.63248L1.24335 3.58394L3.6072 1.20928L5.97164 3.58394Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0446 12.0786C9.79149 12.0786 9.58229 11.8905 9.54918 11.6465L9.54462 11.5786V2.5001C9.54462 2.22395 9.76847 2.0001 10.0446 2.0001C10.2977 2.0001 10.5069 2.1882 10.5401 2.43225L10.5446 2.5001V11.5786C10.5446 11.8548 10.3208 12.0786 10.0446 12.0786Z",
    fill: "#7083A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3989 11.9318C10.2212 12.1103 9.9424 12.1266 9.74633 11.9805L9.69017 11.9318L6.97165 9.20073C6.77684 9.00501 6.77758 8.68843 6.97329 8.49362C7.15121 8.31652 7.42902 8.30103 7.62443 8.44671L7.68039 8.49525L10.0447 10.8707L12.4087 8.49525C12.5858 8.31733 12.8635 8.30055 13.0596 8.44534L13.1158 8.49362C13.2937 8.67072 13.3105 8.94846 13.1657 9.14454L13.1174 9.20073L10.3989 11.9318Z",
    fill: "#7083A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescSort);
export default __webpack_public_path__ + "static/media/desc-sort.86544094b40038c750ae22ff9ac172aa.svg";
export { ForwardRef as ReactComponent };